import React from 'react';
import { formatCurrency } from '../../../../utils/helpers';

/**
 * Interest Rate Tooltip content
 * @param {{ account: any }} props
 */
const InterestRateTooltip = ({ account }) => {
    const interestRateTiers = account?.product?.interestRateTiers;
    const isInstantAccessCashIsa = account?.product?.productType === 'INSTANT_ACCESS_CASH_ISA';
    
    if (!interestRateTiers || interestRateTiers.length === 0) {
        return null;
    }

    return (
        <>
            <h3>What's the interest rate?</h3>
            <ul>
                {interestRateTiers
                    .sort((/** @type {any} */ a, /** @type {any} */ b) => a.minBalance > b.minBalance ? -1 : 1)
                    .filter((/** @type {any} */ tier) => !isInstantAccessCashIsa || tier.rate > 0)
                    .map((/** @type {any} */ tier, /** @type {number} */ index) => {
                        return tier.rate === 0.00
                            ? (
                                <li key={index}>
                                    However, if it's equal to or under {formatCurrency(tier.maxBalance)}, you won't earn any interest.
                                </li>
                            )
                            : (
                                <li key={index}>
                                    You'll earn {tier.rate.toFixed(2)}%^ on your <b>entire</b> balance when it's between {formatCurrency(isInstantAccessCashIsa ? 1000 : tier.minBalance, !isInstantAccessCashIsa)} - {formatCurrency(tier.maxBalance, !isInstantAccessCashIsa)}.
                                </li>
                            );
                    })
                }
                {isInstantAccessCashIsa && (
                    <li>However, if it&apos;s equal to or under {formatCurrency(999.99)}, you won&apos;t earn any interest.</li>
                )}
                <li key={interestRateTiers.length}>
                    ^This is gross p.a., which is the rate you earn per year before tax.
                </li>
            </ul>
        </>
    );
};

export default InterestRateTooltip;
